import Layout from "../components/Layout";
import { Helmet } from "react-helmet-async";

const About = () => {
  return (
    <Layout>
      <Helmet>
        <title>About | TriTech Tunisie</title>
        <meta
          name="description"
          content="Learn more about TriTech Tunisie, our journey, milestones, and commitment to quality pool construction and equipment."
        />
      </Helmet>

      {/* Hero */}
      <section className="py-32 px-6 text-center bg-blue-50">
        <h1 className="text-4xl font-bold text-primary">About TriTech Tunisie</h1>
        <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
          TriTech Tunisie is a leading company specializing in the design, construction, and
          supply of high-quality swimming pools and pool equipment. We bring innovation and
          excellence to every drop.
        </p>
      </section>

      {/* Our Office & Company */}
      <section className="py-20 px-6 bg-white text-left max-w-6xl mx-auto space-y-16">
        <div>
          <h2 className="text-2xl font-semibold text-primary">Our Office</h2>
          <p className="mt-2 text-gray-600">
            Strategically located in Tunisia, our headquarters is home to a passionate team
            dedicated to delivering world-class aquatic environments. We embrace modern
            design, eco-efficiency, and personalized service.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-primary">Our Company</h2>
          <p className="mt-2 text-gray-600">
            TriTech Tunisie was founded with the vision of transforming outdoor living.
            With deep expertise in hydraulics, architecture, and smart pool technology, we
            offer turnkey pool construction solutions and a complete range of trusted equipment.
          </p>
        </div>
      </section>

      {/* Founding Story */}
      <section className="py-20 px-6 bg-blue-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-primary mb-4">Our Founding Story</h2>
          <p className="text-gray-600 mb-6">
            What started as a family passion for design and wellness became a full-fledged
            mission: delivering tailored aquatic solutions that stand the test of time and Tunisian climate.
          </p>
          <blockquote className="italic text-lg text-gray-800 border-l-4 border-primary pl-4">
            "We believe a pool is more than a luxury—it’s a lifestyle. We create spaces where
            families thrive and memories are made."
            <br />
            <span className="block mt-2 text-sm text-gray-500">
              – Dr. Achraf Othman, Founder & Technical Director
            </span>
          </blockquote>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl font-bold text-primary mb-10 text-center">
            Our Journey & Milestones
          </h2>
          <ol className="relative border-l border-primary space-y-10">
            <li>
              <div className="ml-6">
                <span className="text-primary font-semibold">2018</span>
                <h3 className="text-lg font-bold text-gray-800">TriTech Established</h3>
                <p className="text-sm text-gray-600">
                  TriTech Tunisie is founded, focusing on custom pool builds and quality service.
                </p>
              </div>
            </li>
            <li>
              <div className="ml-6">
                <span className="text-primary font-semibold">2020</span>
                <h3 className="text-lg font-bold text-gray-800">Equipment Division Launched</h3>
                <p className="text-sm text-gray-600">
                  Expanded into pool pumps, filters, lighting, and accessories with leading brands.
                </p>
              </div>
            </li>
            <li>
              <div className="ml-6">
                <span className="text-primary font-semibold">2022</span>
                <h3 className="text-lg font-bold text-gray-800">Digital Transformation</h3>
                <p className="text-sm text-gray-600">
                  Website and online catalog introduced for streamlined client experience.
                </p>
              </div>
            </li>
            <li>
              <div className="ml-6">
                <span className="text-primary font-semibold">2025</span>
                <h3 className="text-lg font-bold text-gray-800">Smart Pools & IoT Integration</h3>
                <p className="text-sm text-gray-600">
                  Launching next-gen pool automation systems powered by smart monitoring.
                </p>
              </div>
            </li>
          </ol>
        </div>
      </section>

      {/* Infographic */}
      <section className="py-20 bg-blue-100 text-center px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl font-bold text-primary mb-6">
            Why Choose TriTech Tunisie
          </h2>
          <p className="text-gray-600 mb-8">
            From elegant designs to reliable maintenance and equipment—we deliver beauty,
            durability, and peace of mind.
          </p>
          <img
            src="/assets/images/pool-benefits.png"
            alt="TriTech Pool Benefits Infographic"
            className="mx-auto max-w-full"
          />
        </div>
      </section>
    </Layout>
  );
};

export default About;
